import { api } from '@/apis';
import { dioStates } from '@/utils/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { endOfDay, startOfDay } from 'date-fns';

export function useTelematicsBoxPolls(imei, date) {
  const startTime = startOfDay(date);
  const endTime = endOfDay(date);

  const queryKey = ['telematicsBoxPolls', imei, startTime, endTime];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { imei } },
        {
          $project: {
            _id: false,
            time: true,
            position: true,
            ignitionOn: true,
            deviceProperties: {
              enqueuedTimestamp: {
                $dateFromString: {
                  dateString: '$deviceProperties.enqueuedTimestamp',
                },
              },
              deviceSignalStrength: true,
              isValidated: true,
              batteryVoltage: true,
              driverId: true,
            },
            ...Object.fromEntries(
              Object.keys(dioStates).map((key) => [key, true]),
            ),
          },
        },
        {
          $match: {
            'deviceProperties.enqueuedTimestamp': {
              $gte: startTime,
              $lt: endTime,
            },
          },
        },
        { $sort: { 'deviceProperties.enqueuedTimestamp': 1 } },
      ];

      return await api
        .post('pipeline/telematicsBoxPolls', { json, signal })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
